import { utility } from "various-ui";

/**@name 数据排序过滤
 * @description 对传入的数据列表进行排序与过滤
 * @param { Array } data    --  数据源
 * @param { String } key    --  排序的字段Key
 * @param { String } sort   --  排序方式只接受asc, desc
 * @param { String } queryKey   --  过滤的字段Key
 * @param { String } query      --  过滤的字段包含属性
 */
export const filter = (data: any[], key: string, sort: string, query: string, queryKey: string | string[]) => {
    let result = utility.cloneDeep(data);
    // 根据关键词过滤数据
    if (query && queryKey && queryKey.length > 0) {
        result = result.filter((val: any) => {
            for (let i = 0, l = queryKey.length; i < l; i++) {
                const value = val[queryKey[i]]?.toString ? val[queryKey[i]].toString() : "";
                if (value.toLocaleLowerCase().includes(query.toLocaleLowerCase())) {
                    return true;
                }
            }
        });
    }

    // 根据排序方式过滤数据
    try {
        if (key && sort) {
            switch (sort) {
                case "asc": {
                    result = result.sort((a: any, b: any) => {
                        const aValue = isNaN(Number(a[key])) ? a[key] : Number(a[key]);
                        const bValue = isNaN(Number(b[key])) ? b[key] : Number(b[key]);
                        if (aValue.localeCompare) {
                            return aValue.localeCompare(bValue);
                        } else {
                            return aValue - bValue;
                        }
                    });

                    break;
                }
                case "desc": {
                    result = result.sort((a: any, b: any) => {
                        const aValue = isNaN(Number(a[key])) ? a[key] : Number(a[key]);
                        const bValue = isNaN(Number(b[key])) ? b[key] : Number(b[key]);
                        if (bValue.localeCompare) {
                            return bValue.localeCompare(aValue);
                        } else {
                            return bValue - aValue;
                        }
                    });

                    break;
                }
            }
        }
    } catch {
        return result;
    }

    return result;
};
